// User-supplied agency poster, transcribed 2026-09-13. Display content only.
export type AgencyPolicyBlock =
  | { type: "paragraph"; text: string; emphasis?: boolean }
  | { type: "list"; items: string[]; ordered?: boolean; emphasis?: boolean }
  | { type: "heading"; text: string }
  | { type: "table"; caption: string; columns: string[]; rows: string[][]; note?: string };

export type AgencyPolicySection = { id: string; title: string; blocks: AgencyPolicyBlock[] };

export const agencyIntroSections: AgencyPolicySection[] = [
  {
    id: "rebate-model",
    title: "提成返点（无限代理模式）",
    blocks: [
      { type: "paragraph", text: "自定义方案（自身返点范围内）给下级开户或生成推广链接，收益自己决定，支持同点位开通代理；" },
      { type: "paragraph", text: "例：投注流水1W，A自身点位300，开设下级B点位200，则每1w流水=100元提成，下级B同点位（200）开通代理C，则C不对B产生提成收益仅对代理A产生收益（1w流水=100元提成）；" },
      { type: "paragraph", text: "其他游戏根据点位差额同理，且是团队无限级模式享受点位差额。" },
      {
        type: "table", caption: "团队提成示例", columns: ["代理与点位", "投注与提成"], rows: [
          ["总代理A：300/W", "直属下级收益：100+100=200；团队下级收益：100+100=200。"],
          ["直属下级B：200/W", "投注1w；自身投注提成：200；直属下级收益：50；给总代A提供提成：100。"],
          ["直属下级B1：200/W", "投注1w；自身投注提成：200；直属下级收益：0；给总代A提供提成：100。"],
          ["团队下级C：150/W", "投注1w；自身投注提成：150；给上级B提供提成：50；给总代A提供提成：100。"],
          ["团队下级C1：200/W", "投注1w；自身投注提成：200；给上级B提供提成：0；给总代A提供提成：100。"],
        ],
      },
      { type: "list", items: [
        "可同点位推广发展下级，只要有点位差即享有提成收益；",
        "所有提成收益于次日18:00之前自动发放到账户；",
        "若某个注单或有效投注流水计算提成金额不足0.01元时，不予发放，请勿纠结；",
      ] },
    ],
  },
  {
    id: "commission-plan",
    title: "合营佣金计划",
    blocks: [
      {
        type: "table", caption: "合营佣金比例", columns: ["当月有效新增＋有效活跃", "佣金比例", "负盈利"], rows: [
          ["5个有效活跃", "50%", "无要求"],
          ["5个有效新增＋5个有效活跃", "60%", "无要求"],
          ["10个有效新增＋10个有效活跃", "65%", "无要求"],
          ["25个有效新增＋25个有效活跃", "70%", "无要求"],
          ["50个有效新增＋50个有效活跃", "75%", "无要求"],
        ],
      },
      { type: "list", items: [
        "有效新增标准：当月注册且累计存款≥500，或存款≥100且有效流水≥1000",
        "有效活跃标准：当月累计存款≥500或有效投注额≥3000；",
      ] },
      { type: "paragraph", emphasis: true, text: "佣金计算方式：（总输赢－返水－优惠活动－邀请好友－流水提成（包含直属＋团队）－代理扶持红利－资金费－平台费＋上月结余）×佣金比例=最终佣金；" },
      { type: "list", items: [
        "同一姓名，同一收款账户，同一联系方式，同一IP，同一邮箱，只能申请一个代理账户；",
        "同一姓名，同一收款账户，同一联系方式，同一IP，同一邮箱的会员只计算一个有效新增/活跃会员下线。",
        "任何个人套利、团伙套利，凑数、卡标准、不诚实行为平台有权调整佣金比例或取消发放；",
      ] },
      { type: "heading", text: "关于佣金支付" },
      { type: "list", ordered: true, items: [
        "支付时间：每月的7–15号支付上月佣金。例如：合作伙伴3月份所产生的佣金，在4月份7–15号期间进行发放；",
        "净盈利负值：若当月净盈利值为负值。则负值金额会累计到下月净盈利中，直至净盈利变成正数，才会产生佣金；",
        "最低支付：佣金最低支付金额为100元，如果当月佣金未达到最低支付要求，则佣金继续累计，直到达到最低支付金额；",
        "若当月活跃会员少于5人，则当月无佣金，并且产生的正盈利不累计，负盈利累计到下个月，直到变为正数。请谨记任何使用无诚信的方法以骗取佣金将会被永久冻结账户，并被终止合作关系，所有佣金一概不予发放。",
        "代理线下会员受平台监管，平台风控部门有权利跟踪观察代理线下会员的投注状况，代理线下的会员必须遵守平台的会员条例，政策及操作程序。平台保留、拒绝或冻结代理与会员账户的权利；",
        "严禁任何代理在自己线下开启会员账号进行投注，代理不得操控代理线下会员进行投注，代理线下大批量会员出现异常投注等情况，平台有权终止合作，取消佣金，并永久冻结会员账户的本金及盈利；",
      ] },
    ],
  },
];
